class SolrParams {
  // mandatory variables
  q = "*";
  // optional variables
  fq = [];
  sort = undefined;
  start = undefined; // default = 0
  rows = undefined; // default = 10
  hl = undefined; // default = on
  hl_fl = undefined; // default = content
  facet = undefined;
  facet_field = undefined;
  facet_sort = undefined;
  facet_limit = undefined;

  /*
    constants configured by the server (client can't overide)
    fl = "id,dcTitle,dcTitleString,dcDate,dcCreator,dcDescription,dcSubject,storageLocation,dcFormat,dcType,dcIsPartOf,dcAccessRights,importTime"
    wt = "json"
    indent = "on"
    q.op = "AND"
    */

  toQuerySring() {
    const p = new URLSearchParams();

    // q
    if (this.q != null) p.set("q", this.q);

    // fq (append each filter separately; Solr ANDs them)
    if (this.fq && this.fq.length > 0) {
      const joined = this.fq.map((f) => `(${f})`).join(" AND ");
      p.set("fq", joined);
    }
    // sort/start/rows — keep zeros
    if (this.sort != null) p.set("sort", this.sort);
    if (this.start != null) p.set("start", String(this.start));
    if (this.rows != null) p.set("rows", String(this.rows));

    // highlighting
    if (this.hl != null) p.set("hl", this.hl);
    if (this["hl_fl"] != null) p.set("hl.fl", this["hl_fl"]);

    // faceting
    if (this.facet != null) p.set("facet", this.facet);
    if (this["facet_field"] != null) p.set("facet.field", this["facet_field"]);
    if (this["facet_sort"] != null) p.set("facet.sort", this["facet_sort"]);
    if (this["facet_limit"] != null) p.set("facet.limit", this["facet_limit"]);
    return p;
  }
}

export default SolrParams;
